export function isUserLoggedin(userData) {
  let isLoggedin = false;
  if (userData && userData.isLoggedIn && userData.getUid()) {
    isLoggedin = true;
  }
  return isLoggedin;
}
export default { isUserLoggedin };
